import { render } from "./UiSearch.vue?vue&type=template&id=5d48b7c2&scoped=true&ts=true"
import script from "./UiSearch.vue?vue&type=script&lang=ts"
export * from "./UiSearch.vue?vue&type=script&lang=ts"

import "./UiSearch.vue?vue&type=style&index=0&id=5d48b7c2&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d48b7c2"]])

export default __exports__